export class MethodofOperation {
  public static mapping = {
    Frequency: "doc_count",
    Percentage: "doc_percentage",
    Proportion: "doc_percentage",
    default: "doc_count",
    Mean: "doc_count"
  };
}



// WEBPACK FOOTER //
// ./src/app/shared/constants/methodofOperation.ts